/* ==========================================================================
   The Master Injector, theme behaviour
   --------------------------------------------------------------------------
   The single JavaScript file this build adds. Everything else is a Theme
   Editor setting or a rule in tmi.css. Keep it to approved functionality that
   cannot be reached any other way, and keep it defensive: nothing here may
   throw if Desert changes its markup.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     1. Product gallery, initialise the slider Desert leaves un-initialised

     Desert's <product-media> element runs its Swiper set-up from
     connectedCallback. On the product template the element is upgraded while
     its own children are still being parsed, so its querySelector for
     [data-product-images-<id>] returns null, slideCount is 0 and
     new Swiper(selector) matches nothing. The gallery then renders as a
     stack of full-size images with no thumbnails, no arrows and no counter.

     The approved design (PRODUCT-PAGE.md 2.1) needs the single-frame gallery
     with a thumbnail strip, so the element is re-initialised once the DOM is
     parsed. Desert's own init() is reused rather than reimplemented, and the
     call is skipped when Swiper already attached, so nothing is set up twice.
     ---------------------------------------------------------------------- */

  function initProductGalleries(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('product-media');

    Array.prototype.forEach.call(galleries, function (gallery) {
      if (typeof gallery.init !== 'function') return;

      var id = gallery.dataset ? gallery.dataset.id : null;
      if (!id) return;

      var frame = gallery.querySelector('[data-product-images-' + id + ']');
      if (!frame) return;

      // Already running: Swiper stamps this class on the container it owns.
      if (frame.classList.contains('swiper-initialized')) return;

      try {
        gallery.init();
      } catch (e) {
        /* Never let a gallery take the page down. */
      }
    });
  }

  /* ------------------------------------------------------------------------
     2. Collection carousel, subheading into the caption stack

     HOMEPAGE-SECTIONS 12 and references/component-carousel.png put the tile
     subheading directly above the tile heading, both always visible over the
     image, with only the description revealed on hover.

     Desert renders the subheading in .collection-icon-wrapper, a separate
     absolutely-positioned band inside .collection-image, and the heading in
     .collection-title-wrapper, a separate overlay anchored to the bottom of
     the card. The two live under different parents, so no CSS rule can stack
     them: the gradient scrim needs .collection-image to fill the card, while
     the subheading needs to sit on top of a caption whose height varies with
     the heading's line count.

     Moving the one node is the smallest change that produces the approved
     result. No copy is created here and nothing is removed - the element and
     its contents are Desert's own, rendered from the block's subheading
     setting, and simply reparented into the caption it belongs above.
     ---------------------------------------------------------------------- */

  function stackCarouselSubheadings(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.collection-card');

    Array.prototype.forEach.call(cards, function (card) {
      var subheading = card.querySelector('.collection-icon-wrapper');
      var caption = card.querySelector('.collection-title-wrapper');
      if (!subheading || !caption) return;
      if (caption.contains(subheading)) return;
      if (!subheading.querySelector('.collection-name')) return;

      caption.insertBefore(subheading, caption.firstChild);
      subheading.classList.add('tmi-subheading-stacked');
    });
  }

  /* ------------------------------------------------------------------------
     3. Announcement bar, scheduled message

     sections/announcement-bar.liquid hides or shows the scheduled text from
     the server clock, but storefront pages are cached and a visitor can keep
     a tab open across the start or end time. The window is re-checked here
     against the browser clock on load and every minute. The times carry their
     UTC offset, so the switch happens at the same instant for every visitor
     whatever their time zone.
     ---------------------------------------------------------------------- */

  function applyAnnouncementSchedules(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-tmi-schedule-start]');
    var now = Date.now();

    Array.prototype.forEach.call(items, function (item) {
      var start = Date.parse(item.getAttribute('data-tmi-schedule-start'));
      var end = Date.parse(item.getAttribute('data-tmi-schedule-end'));
      var standard = item.querySelector('[data-tmi-default]');
      var scheduled = item.querySelector('[data-tmi-scheduled]');
      if (isNaN(start) || isNaN(end) || !standard || !scheduled) return;

      var live = now >= start && now < end;
      scheduled.hidden = !live;
      standard.hidden = live;
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    initProductGalleries();
    stackCarouselSubheadings();
    applyAnnouncementSchedules();
    setInterval(applyAnnouncementSchedules, 60000);
  });

  // Section re-render in the Theme Editor, and Desert's own section refreshes.
  document.addEventListener('shopify:section:load', function (event) {
    initProductGalleries(event.target);
    stackCarouselSubheadings(event.target);
    applyAnnouncementSchedules(event.target);
  });
})();
